import React, { useState } from "react";
import "../styles/ContactUs.css";
import "../styles/Form/FreeEvaluationForm.css";
import { base_url } from "../ReuableFunctions/Blogs";

const FreeEvaluationForm = ({ setShowForm, handleSetSucess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false); // New state variable
  const initialFormState = {
    startupName: "",
    startupStage: "",
    targetMarketValidated: "false",
    hasCoFounder: "false",
    mvpBuilt: "false",
    hasFundsForThreeMonths: "false",
    contactNumber: "",
    founderEmail: "",
    evaluationType: "FREE",
    teamStrength: "false",
  };
  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber") {
      const regex = /^[0-9+]*$/; // Allows numbers and (+)sign
      if (!regex.test(value)) {
        return; // Prevent updating state if invalid input
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOptionSelect = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "hasCoFounder" && { teamStrength: value }),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${base_url}/core/lovencoders/startup-evaluation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.status === 400) {
        const data = await response.json(); // parse JSON response
        let errorMessage = "";
        if (data?.message) {
          errorMessage += ` ${data.message}`;
        }
        let responseData = {
          type: "error",
          message: errorMessage,
        };
        handleSetSucess(true,responseData);
        return;
      }

      if (response.ok) {
        let responseData = await response.json();
        setShowForm(false);
        let data = {
          type: "success",
          message: "Form submitted successfully.",
        };
        handleSetSucess(true, data);
        setFormData(initialFormState);
      } else {
        const data = await response.json(); // parse JSON response
        let responseData = {
          type: "error",
          message: data?.message || "Something went wrong",
        };
        handleSetSucess(responseData);
      }
      setIsSubmitting(false);
    } catch (error) {
      console.log("Error", error?.message);
      let responseData = {
        type: "error",
        message: error?.message || "Something went wrong",
      };
      handleSetSucess(true,responseData);
      setIsSubmitting(false);
    }
    setIsSubmitting(false);
  };

  const handleClose = () => {
    setShowForm(false);
  };
  return (
    <div className="free-evaluation-form-container">
      <form id="free-evaluation-form" onSubmit={handleSubmit}>
        <div id="free-evaluation-form-innercontainer">
          <div className="free-evaluation-form-close" onClick={handleClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.66829 23.6673L0.334961 21.334L9.66829 12.0007L0.334961 2.66732L2.66829 0.333984L12.0016 9.66732L21.335 0.333984L23.6683 2.66732L14.335 12.0007L23.6683 21.334L21.335 23.6673L12.0016 14.334L2.66829 23.6673Z"
                fill="#1C1B1F"
                fillOpacity="0.5"
              />
            </svg>
          </div>
          <div className="free-evaluation-form-title">
            Your Free Startup Business Report{" "}
          </div>
          <div className="free-evaluation-form-desc">
            Wondering where your startup stands? Take our <b>free Startup</b>{" "}
            Stage Evaluation Test for a personalized report on your business,
            growth, and key improvements.
          </div>
          <div className="free-evaluation-form-input-container">
            <div className="form-input-field-container">
              <div className="input-container">
                <label htmlFor="startupName">
                  Startup Name <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  name="startupName"
                  id="startupName"
                  placeholder="Enter Startup Name"
                  value={formData.startupName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="startupStage">Startup Stage</label>
                <select
                  name="startupStage"
                  id="startupStage"
                  onChange={handleChange}
                >
                  <option value="">Select Stage</option>
                  <option value="Idea Stage">Idea Stage</option>
                  <option value="Valley Stage">Valley Stage</option>
                  <option value=">Growth Stage">Growth Stage</option>
                </select>
              </div>
            </div>
            <div className="form-input-field-container">
              <div className="input-container">
                <label htmlFor="startupName">
                  Contact Number <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  name="contactNumber"
                  id="contactNumber"
                  placeholder="+91XXXXXXXXXX"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="founderEmail">
                  Email Id <span className="danger">*</span>
                </label>
                <input
                  type="email"
                  name="founderEmail"
                  id="founderEmail"
                  placeholder="Enter Email Id"
                  value={formData.founderEmail}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-input-field-container"></div>

            <div className="form-assessment-container">
              <label>Self Assessment</label>
              {[
                {
                  question: "Have you validated your target market?",
                  field: "targetMarketValidated",
                },
                {
                  question: "Do you have a co-founder/team?",
                  field: "hasCoFounder",
                },
                { question: "Have you built an MVP?", field: "mvpBuilt" },
                {
                  question:
                    "Do you have enough funds for 3 months of operations?",
                  field: "hasFundsForThreeMonths",
                },
              ].map(({ question, field }, index) => (
                <div key={index} className="form-assessment-input-container">
                  <div className="form-assessment-input-question">
                    {index + 1}. {question}
                  </div>
                  <div className="form-assessment-options-container">
                    <div
                      className={`form-assessment-option ${
                        formData[field] === "false" ? "selected" : ""
                      }`}
                      onClick={() => handleOptionSelect(field, "false")}
                      style={{
                        backgroundColor:
                          formData[field] === "false"
                            ? "rgba(199, 49, 61, 1)"
                            : "",
                        color: formData[field] === "false" ? "white" : "",
                      }}
                    >
                      No
                    </div>
                    <div
                      className={`form-assessment-option ${
                        formData[field] === "true" ? "selected" : ""
                      }`}
                      onClick={() => handleOptionSelect(field, "true")}
                      style={{
                        backgroundColor:
                          formData[field] === "true"
                            ? "rgba(199, 49, 61, 1)"
                            : "",
                        color: formData[field] === "true" ? "white" : "",
                      }}
                    >
                      Yes
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div>
              <button
                type="submit"
                className="evaluation-btn form-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FreeEvaluationForm;
